import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Tooltip, Spin, Input, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPosts, getPost, getPostCommenrts, getPostCats, getCatPosts } from '../../../../core/actions/postGet';
import { addVote, sendComment, likeComment, unLikeComment, sendReplyComment, likeSubComment, unLikeSubComment } from '../../../../core/actions/uploadPost';
import moment from 'moment';
import Footer from '../../components/footer/footer';
import PostCard from '../../components/blog/postcard'
import MainComment from '../../components/blog/maincomment'
import MainCommentForm from '../../components/blog/maincommentform'
import Banner from '../../components/blog/banner'
import OurPost from '../../components/blog/ourpost'
const { Meta } = Card;
const { TextArea } = Input;

class Post extends Component {
  constructor(props) {
    super(props);

    this.state = {
      post: {},
      posts: [],
      voteAnimation: false,
      currentLikes: 0,
      showCurrentLikes: false,
      profile: {},
      likedAlready: false,
      toggleAction: false,
      comments: [],
      postcats: [],
      catPosts: []
    }
  }

  componentDidMount() {
    const { slug } = this.props.match.params;
    const { posts, postcats, comments } = this.state
    this.props.getPost(slug)
    if (!posts.length) {
      this.props.getPosts()
    }
    if (!postcats.length) {
      this.props.getPostCats()
    }
    if (!comments.length) {
      this.props.getPostCommenrts(slug)
    }
  }

  getCommentsAgain = () => {
    const { slug } = this.props.match.params;
    this.props.getPostCommenrts(slug)
  }


  checkIfUserLicked = (likers, id) => {
    let checkUser = []
    checkUser = likers.filter((user) => {
      return user === id
    })
    if (!checkUser.length) {
      this.setState({
        likedAlready: false
      })
    } else {
      this.setState({
        likedAlready: true
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { posts, post, profile, comments, postcats, postupload, catPosts, coursePageError } = nextProps;
    if(coursePageError) {
      this.props.history.push('/error')
    }
    this.setState({
      catPosts
    })
    if (posts.length > 0) {
      this.setState({
        posts
      })
    }
    if (postcats.length > 0) {
      this.setState({
        postcats
      })
    }
    if (comments.length > 0) {
      this.setState({
        comments
      })
    }
    if (post) {
      this.setState({
        post
      }, () => {
        if (this.state.post.likers) {
          this.checkIfUserLicked(this.state.post.likers, profile.uid)
        }
      })
    }
    if (profile) {
      this.setState({
        profile: profile
      })
    }
    if (postupload.uploadcommentSuccess) {
      // message.success("Comment made successfully!")
      this.setState({
        comments: []
      })
      const { slug } = this.props.match.params;
      this.props.getPostCommenrts(slug)
      this.setState({
        comments: this.props.comments
      })
      // this.props.stopCommentRefresh()
    }
  }

  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  vote = () => {
    let { currentLikes, post, profile } = this.state
    if (!profile.uid) {
      message.info('You need to be logged in!');
      this.toggleModal()
    } else {
      let likers = post.likers
      likers.push(profile.uid)

      this.setState({
        voteAnimation: true,
        currentLikes: ++currentLikes,
        showCurrentLikes: true
      })
      setTimeout(() => {
        this.setState({
          voteAnimation: false,
          showCurrentLikes: false
        })
      }, 500);
      var postData = {
        postId: post.id,
        likers
      }
      this.props.addVote(postData)
    }
  }

  deleteCommemt = (commentId) => {

  }

  render() {
    const { post, posts, voteAnimation, currentLikes, showCurrentLikes, likedAlready, toggleAction, postcats, comments, catPosts } = this.state
    // const { comments } = this.props
    // console.log(post.postcategory)
    let effectVote = voteAnimation ? 'tada' : ''
    let currentVoteEffect = voteAnimation ? 'bounceIn' : ''
    let removePointetEvent = currentLikes || likedAlready ? 'removePointEvent' : ''
    let loading = !posts.length > 0;

    return (
      <div>
        {
          post.commentsNo > 0 ?
            comments.length ?
              <div className="x-blogPost-page">
                <TopNav />
                <br />
                <OurPost posts={posts} postcats={postcats} comments={comments} post={post} profile={this.props.profile} postId={post.id} sendComment={this.props.sendComment} sendReplyComment={this.props.sendReplyComment} likeComment={this.props.likeComment} unLikeComment={this.props.unLikeComment} likeSubComment={this.props.likeSubComment} unLikeSubComment={this.props.unLikeSubComment} 
                getCatPosts={this.props.getCatPosts}
                catPosts={catPosts}
                />
                <Footer />
              </div> :
              <div className="x-loader">
                <Icon type="loading" style={{ fontSize: 60 }} spin />
              </div> :
            posts.length ?
              <div className="x-blogPost-page">
                <TopNav />
                <br />
                <OurPost posts={posts} postcats={postcats} comments={comments} post={post} profile={this.props.profile} postId={post.id} sendComment={this.props.sendComment} sendReplyComment={this.props.sendReplyComment} likeComment={this.props.likeComment} unLikeComment={this.props.unLikeComment} likeSubComment={this.props.likeSubComment} unLikeSubComment={this.props.unLikeSubComment}
                getCatPosts={this.props.getCatPosts}
                catPosts={catPosts}
                />
                <Footer />
              </div> :
              <div className="x-loader">
                <Icon type="loading" style={{ fontSize: 60 }} spin />
              </div>
        }
        {/* <TopNav />
        <div className="x-construction">
          <Spin indicator={<Icon type="loading" />} /> <br /><br /> Please check back later
        </div>
        <Footer /> */}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
  post: state.allPosts.post,
  posts: state.allPosts.posts,
  comments: state.allPosts.comments,
  postcats: state.allPosts.postcats,
  postupload: state.post,
  catPosts: state.allPosts.catPosts,
  coursePageError: state.allPosts.coursePageError
});

const mapDispatchToProps = dispatch => ({
  getPost: slug => dispatch(getPost(slug)),
  getPosts: () => dispatch(getPosts()),
  addVote: id => dispatch(addVote(id)),
  sendComment: commentDetails => dispatch(sendComment(commentDetails)),
  sendReplyComment: replyCommentDetails => dispatch(sendReplyComment(replyCommentDetails)),
  likeComment: commentDetails => dispatch(likeComment(commentDetails)),
  unLikeComment: commentDetails => dispatch(unLikeComment(commentDetails)),
  getPostCommenrts: slug => dispatch(getPostCommenrts(slug)),
  getPostCats: () => dispatch(getPostCats()),
  unLikeSubComment: commentDetails => dispatch(unLikeSubComment(commentDetails)),
  likeSubComment: commentDetails => dispatch(likeSubComment(commentDetails)),
  getCatPosts: (slug) => dispatch(getCatPosts(slug))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Post);
